import React, {
  useContext,
  createContext,
  useState,
  useEffect,
  useCallback
} from 'react';
import { useAuth } from 'hooks/useAuth/useAuth';
import { useLocation } from 'react-router-dom';
import { ROUTES } from 'utils/constants/routes';

export const AlertContext = createContext();

export const ProvideAlert = ({ children }) => {
  const alert = useProvideAlert();
  return (
    <AlertContext.Provider value={alert}>{children}</AlertContext.Provider>
  );
};

export const useAlert = () => {
  return useContext(AlertContext);
};

const useProvideAlert = () => {
  const { profile } = useAuth();
  const [isShowingAlert, setIsShowingAlert] = useState(false);
  const [text, setText] = useState('');
  let location = useLocation();

  const openAlert = useCallback(() => {
    if (!profile) {
      setIsShowingAlert(false);
    } else {
      setIsShowingAlert(!isShowingAlert);
    }
  }, [isShowingAlert, profile]);

  const closeAlert = useCallback(() => {
    setIsShowingAlert(false);
  }, []);

  useEffect(() => {
    if (location?.pathname !== ROUTES.OFFERS) {
      closeAlert();
    }
  }, [closeAlert, location]);

  return {
    isShowingAlert,
    openAlert,
    text,
    setText,
    closeAlert
  };
};
